import { TextField } from '@mui/material';
import React from 'react';

const CustomTextField = ({ label, value, name, disabled, onChange, type, startAdornment, endAdornment, marginBottom = '15px', ...props }) => {
    return (
        <TextField
            label={label}
            name={name}
            value={value}
            onChange={onChange}
            type={type}
            fullWidth
            variant="outlined"
            disabled={disabled}
            sx={{
                mb: 2,
                '& .MuiInputBase-root': {
                    fontSize: { xs: '0.9rem', md: '1rem' },          // Unified font size
                    padding: { xs: '0px', md: '0px' },             // Consistent padding
                },
                '& .MuiInputLabel-root': {
                    fontSize: { xs: '0.85rem', md: '1rem' },         // Label font size
                },
                '& .MuiOutlinedInput-root': {
                    borderRadius: 2,                                 // Consistent border radius
                },
            }}
        />

    );
};

export default CustomTextField;
